<template>
  <div
    class="absolute flex items-center justify-center hotspot"
    :style="'top:' + content.y * 100 + '%; left:' + content.x * 100+ '%'"
    ref="hotspot"
  >
    <transition
      @enter="animEnterPlus"
      @leave="animLeavePlus"
    >
      <div
        @click="toggleActive"
        v-show="!active"
        style="filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));"
        class="br3 w2 h2 white flex justify-center items-center absolute heartbeat"
        :class="{
          'bg-purple': brand === 'lh',
          'bg-yellow': brand === 'lq'
        }"
        :style="'animation-delay: ' + (index * 0.2) + 's'"
        ref="smallSquare"
      >
        <div ref="plusIcon">
          <simple-svg
            :filepath="icon"
            class="w1 h1"
            :class="{
              'white': brand === 'lh',
              'dark-gray': brand === 'lq',
            }"
          />
        </div>
        <div
          class="triangle-down-small absolute"
          :class="{
            'b--purple': brand === 'lh',
            'b--yellow': brand === 'lq'
          }"
        />
      </div>
    </transition>
    <transition
      @enter="animEnterIcon"
      @leave="animLeaveIcon"
    >
      <div
        v-show="active"
        @click="toggleActive"
        class="br3 pa3 relative flex justify-center items-center absolute"
        :class="{
          'bg-purple white': brand === 'lh',
          'bg-yellow dark-gray': brand === 'lq'
        }"
        style="filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25))"
        ref="bigSquare"
      >
        <simple-svg
          :filepath="markerIcon"
          class="z-1"
          width="2.7rem"
          height="2.7rem"
        />
        <div
          ref="label"
          class="absolute ph4 pv2 br-pill z-0"
          :class="{
            'bg-purple white': brand === 'lh',
            'bg-yellow dark-gray': brand === 'lq'
          }"
          style="left: 60%; white-space: pre"
        >
          <div v-html="fixMarkerName" />
          <div v-html=" content.label" />
        </div>
        <div
          class="triangle-down absolute"
          :class="{
            'b--purple': brand === 'lh',
            'b--yellow': brand === 'lq'
          }"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import gsap from 'gsap'
export default {
  name: 'MarkerHotspot',
  props: {
    brand: {
      type: String,
      default: 'lh'
    },
    content: {
      type: Object,
      default: null
    },
    index: {
      type: Number,
      default: null
    }
  },
  computed: {
    fixMarkerName () {
      let str = this.content.room.replace(/_/g, ' ')

      return this.capital_letter(str)
    },
    markerIcon () {
      for (let i = 0; i < this.markerIcons.length; i++) {
        if (this.content.room === this.markerIcons[i].name) {
          return this.markerIcons[i].img
        }
      }
      return null
    }
  },
  data () {
    return {
      active: false,
      icon: require('@/assets/img/icn-plus.svg'),
      markerIcons: [
        {
          name: 'bathroom',
          img: require('@/assets/img/icon-room-bathroom.svg')
        },
        {
          name: 'bedroom',
          img: require('@/assets/img/icon-room-bedroom.svg')
        },
        {
          name: 'cloakroom',
          img: require('@/assets/img/icon-room-cloakroom.svg')
        },
        {
          name: 'study',
          img: require('@/assets/img/icon-room-study.svg')
        },
        {
          name: 'kitchen',
          img: require('@/assets/img/icon-room-kitchen.svg')
        },
        {
          name: 'garage',
          img: require('@/assets/img/icon-room-garage.svg')
        },
        {
          name: 'dining',
          img: require('@/assets/img/icon-room-dining.svg')
        },
        {
          name: 'lounge',
          img: require('@/assets/img/icon-room-lounge.svg')
        },
        {
          name: 'hallway',
          img: require('@/assets/img/icon-room-hallway.svg')
        },
        {
          name: 'family_room',
          img: require('@/assets/img/icon-room-family-room.svg')
        },
        {
          name: 'master_bedroom',
          img: require('@/assets/img/icon-room-master-bedroom.svg')
        }
      ]
    }
  },
  methods: {
    capital_letter (str) {
      str = str.split(' ')

      for (var i = 0, x = str.length; i < x; i++) {
        str[i] = str[i][0].toUpperCase() + str[i].substr(1)
      }

      return str.join(' ')
    },
    toggleActive () {
      this.active = !this.active
    },
    animInitial () {
      gsap.fromTo('.hotspot', {
        opacity: 0,
        y: -100
      }, {
        opacity: 1,
        ease: 'back',
        y: 0,
        stagger: 0.2,
        delay: 1
      })
    },
    animEnterPlus (el, done) {
      const smallSquare = this.$refs.smallSquare
      const plusIcon = this.$refs.plusIcon
      gsap.to(plusIcon, {
        opacity: 1
      })
      gsap.fromTo(smallSquare, {
        scale: 0
      }, {
        scale: 1,
        onComplete: done
      })
    },
    animLeavePlus (el, done) {
      const plusIcon = this.$refs.plusIcon
      gsap.to(plusIcon, {
        opacity: 0
      })
      const smallSquare = this.$refs.smallSquare
      gsap.fromTo(smallSquare, {
        scale: 0
      }, {
        scale: 2,
        duration: 0.7,
        onComplete: done
      })
    },
    animEnterIcon (el, done) {
      const bigSquare = this.$refs.bigSquare
      const label = this.$refs.label
      gsap.fromTo(bigSquare, {
        opacity: 0,
        scale: 0
      }, {
        scale: 1,
        delay: 0.3,
        duration: 0.4,
        opacity: 1,
        ease: 'back',
        onComplete: done
      })
      gsap.from(label, {
        x: -30,
        opacity: 0,
        delay: 0.4
      })
    },
    animLeaveIcon (el, done) {
      const bigSquare = this.$refs.bigSquare
      gsap.fromTo(bigSquare, {
        scale: 1
      }, {
        scale: 0,
        onComplete: done
      })
    }
  },
  mounted () {
    this.animInitial()
  }
}
</script>
<style>
  .triangle-down{
    width: 0;
    height: 0;
    bottom: -0.9rem;
    border-left: 10px solid transparent !important;
    border-right: 10px solid transparent !important;
    border-top: 15px;
    border-top-style: solid;
  }
  .triangle-down-small{
    width: 0;
    height: 0;
    bottom: -0.35rem;
    border-left: 5px solid transparent !important;
    border-right: 5px solid transparent !important;
    border-top-width: 7px;
    border-top-style: solid;
  }
.heartbeat {
  animation: heartbeat 1.5s ease-in-out infinite both;
}
@keyframes heartbeat {
  from {
    transform: scale(1);
    transform-origin: center center;
    animation-timing-function: ease-out;
  }
  10% {
    transform: scale(0.91);
    animation-timing-function: ease-in;
  }
  17% {
    transform: scale(0.98);
    animation-timing-function: ease-out;
  }
  33% {
    transform: scale(0.87);
    animation-timing-function: ease-in;
  }
  45% {
    transform: scale(1);
    animation-timing-function: ease-out;
  }
}

</style>
